module.exports = __webpack_public_path__ + "media/images/transatlantic-translations-34139b500d28efc7a6ee4f91a64e246d.png";